module.exports = __webpack_public_path__ + "static/media/29.ca5ac7d7.png";